import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=c46d9022&scoped=true&lang=pug"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"
import style0 from "./Noticias.styl?vue&type=style&index=0&id=c46d9022&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46d9022",
  null
  
)

export default component.exports